import { render, staticRenderFns } from "./Sendemail.vue?vue&type=template&id=4db75520&scoped=true"
import script from "./Sendemail.vue?vue&type=script&lang=js"
export * from "./Sendemail.vue?vue&type=script&lang=js"
import style0 from "./Sendemail.vue?vue&type=style&index=0&id=4db75520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db75520",
  null
  
)

export default component.exports